import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetchServices } from "../Redux/slice/homeSlice";
import { Icon } from "@iconify/react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../Api";


const ServiceRap = styled.div`
  .upper-p {
    padding: 5px 15px;
    width: fit-content;
    height: 31px;
    display: flex;
    border: 1px solid #0000001a;
    color: #1a365d;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
  }
  h1 {
    color: #1a365d;
    font-size: 52px;
    line-height: 57px;
    font-weight: 400;
    max-width: 678px;
  }
  h2 {
    color: #1a365d;
    font-size: 48px;
    line-height: 57px;
    font-weight: 400;
  }

  .service-1-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .service-1 img {
    width: 100%;
    height: auto;
    border-radius: 24px;
  }
  .service-1 {
    display: flex;
    flex-direction: column;
    gap: 50px;

    background: linear-gradient(180deg, #f6f5f2 0%, #ffffff 100%);
    padding-top: 160px;
  }
  .service-2-left h2 {
    max-width: 513px;
  }
  .service-2-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .service-2 p {
    color: #000000cc;
    max-width: 502px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }
  .service-2 {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    margin-top: 100px;
  }
  .service-3-upper h2 {
    max-width: 843px;
    text-align: center;
  }
  .service-3-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .service-3-card h4 {
    color: #1a365d;
    font-size: 22px;
    text-align: center;
  }
  .card-3-circle {
    width: 20px;
    height: 20px;
    border-radius: 100px;
    background: #1a365d;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-3-sub p {
    color: #1a365d;
    font-size: 14px;
    font-weight: 400;
  }
  .card-3-sub {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .card-3-all-sub {
    padding: 20px;
    padding-left: 30px;
    border-top: 1px solid #0000001a;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .service-3-card {
    display: flex;
    flex-direction: column;
    padding-top: 20px;
    gap: 20px;
    width: 390px;
    border-radius: 20px;
    background: #ffffff;
    border: 1px solid #0000001a;
  }
  .service-3-down {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: space-between;
    gap: 10px;
  }
  .service-3 {
    display: flex;
    flex-direction: column;
    gap: 40px;
    background: linear-gradient(180deg, #f6f5f2 0%, #ffffff 100%);
    padding-top: 80px;
    padding-bottom: 80px;
    margin-top: 100px;
  }
  .service-4-upper h2 {
    text-align: center;
    max-width: 658px;
  }
  .service-4-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .service-4-card img {
    height: 320px;
    object-fit: cover;
    width: 100%;
    border-radius: 24px;
  }
  .card-4-sub h4 {
    color: #1a365d;
    font-size: 20px;
    line-height: 24px;
    max-width: 162px;
    font-weight: 500;
  }
  .card-4-circle {
    background: #ffffff;
    width: 50px;
    height: 50px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-4-circle svg {
    color: #1a365d;
  }
  .card-4-sub {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    gap: 10px;
  }
  .service-4-card {
    width: 300px;
    border-radius: 24px;
    background: #f6f5f2;
    cursor: pointer;
  }
  .service-4-card:hover {
    background: #0ea5e9;
  }
  .service-4-card:hover .card-4-circle svg {
    color: #0ea5e9;
  }
  .service-4-card:hover .card-4-circle {
    background: #1a365d;
  }
  .service-4-down {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }

  .service-4 {
    margin: 0px 0px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-bottom: 80px;
  }
  .left-5-upper h3 {
    color: #f6f5f2;
    max-width: 444px;
    font-weight: 400;
    font-size: 48px;
    line-height: 57px;
  }
  .left-5-upper img {
    width: 20px;
    height: 20px;
  }
  .left-5-upper {
    display: flex;
    gap: 20px;
    justify-content: space-around;
  }
  .left-5-circle {
    background: #ffffff;
    width: 50px;
    height: 50px;
    align-content: center;
    border-radius: 100px;
  }
  .service-5-left,
  .service-5-right {
    background: #1a365d;
    border-radius: 24px;
    width: 629px;
    height: 550px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
  }
  .service-5-right {
    background: #0ea5e9;
  }
  .right-5-sub h4 {
    color: #1a365d;
    font-weight: 500;
    font-size: 30px;
    line-height: 36px;
    max-width: 389px;
  }
  .right-5-sub {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .right-5-circle {
    background: #1a365d;
    width: 50px;
    height: 50px;
    border-radius: 100px;
    align-content: center;
  }
  .right-5-upper {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  .right-5-inner h4 {
    color: #1a365d;
    font-size: 30px;
    font-weight: 500;
  }
  .right-5-inner p {
    color: #000000cc;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    max-width: 264px;
  }
  .right-5-inner {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .right-5-btn {
    background: #1a365d;
    width: 157px;
    height: 47px;
    align-items: center;
    align-content: center;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    border-radius: 100px;
  }
  .right-5-down {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }
  .service-5 {
    display: flex;
    gap: 10px;
    justify-content: space-between;
  }

  .service-6-card-upper h6 {
    border: 1px solid #0000001a;
    width: 90px;
    height: 31px;
    font-size: 11px;
    font-weight: 500;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1a365d;
  }
  .small-blue-cirlce {
    width: 42px;
    height: 42px;
    background: #38bdf8;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }
  .service-6-card-upper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .service-6-card-middle h5 {
    color: #1a365d;
    font-size: 48px;
    font-weight: 400;
  }
  .service-6-card-middle h4 {
    background: #38bdf8;
    padding: 5px 10px;
    border-radius: 8px;
    color: #1a365d;
    font-size: 48px;
    font-weight: 400;
    width: fit-content;
  }
  .service-6-card-down {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
  }
  .service-6-btn {
    background: #1a365d;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 159px;
    height: 47px;
    border-radius: 100px;
  }
  .service-6-card-down {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
  }
  .service-6-card-middle {
    display: flex;
    gap: 20px;
    flex-direction: column;
  }
  .service-6-card {
    width: 600px;
    height: 330px;
    backdrop-filter: blur(40px);
    padding: 20px;
    background: #ffffffcc;
    border-radius: 24px;
    display: flex;

    transition: all 0.5s ease-in-out;
    justify-content: space-between;
    flex-direction: column;
  }

  .service-6 {
    background-size: cover;
    height: 100vh;
    margin-top: 80px;
    position: relative;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  @media (max-width: 1300px) {
    .service-4-card {
      width: 270px;
    }
    .service-4-card img {
      height: 300px;
    }
  }
  @media (max-width: 1250px) {
    .service-3-card {
      width: 340px;
    }
  }
  @media (max-width: 1150px) {
    .service-4-card {
      width: 320px;
    }
    .service-4-card img {
      height: 340px;
    }
    .service-4-down {
      gap: 20px;
      grid-template-columns: repeat(3, 1fr);
    }
  }
  @media (max-width: 1100px) {
    .service-3-down {
      grid-template-columns: repeat(2, 1fr);
    }
    .service-3-card {
      width: 400px;
    }
  }

  @media (max-width: 1024px) {
    .service-4-down {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 992px) {
    h1 {
      font-size: 45px;
    }
    h2 {
      font-size: 40px;
    }
    .service-2 {
      flex-direction: column;
      align-items: flex-start;
    }
    .service-3-down {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  @media (max-width: 700px) {
    .service-4-down {
      grid-template-columns: repeat(1, 1fr);
    }
    h1 {
      font-size: 32px !important;
      line-height: 40px;
    }
    h2 {
      font-size: 28px;
      line-height: 32px;
    }
  }
  @media (max-width: 600px) {
    /* .service-1 img {
height: 400px;
    } */
  }
  @media (max-width: 500px) {
    /* .service-1 img {
height: 350px;
    } */
    .service-1-upper,
    .service-2,
    .service-2-left {
      align-items: center;
    }
    h1,
    .service-2-left h2,
    .service-2 p {
      text-align: center;
    }
    .service-3-card {
      width: 100%;
    }
    .service-4-card {
      width: 100%;
    }
  }
`;

const Services = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const { serviceObject } = useSelector((state) => state.content);
  console.log(serviceObject);
  const slider = serviceObject?.data?.bannerHeader;
  const whatWeDo = serviceObject?.data?.whatWeDo;
  const whyChoseUs = serviceObject?.data?.whyChoseUs;
  const service = serviceObject?.data?.service;

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, [location.pathname]);

  const handledetails = (id) => {
    navigate(`/services/details/${id}`);
  };
  return (
    <ServiceRap>
      <div className="service-1 containers">
        <div className="service-1-upper">
          <h6 className="upper-p">{slider?.small_title}</h6>
          <h1>
            {" "}
            {slider?.main_title?.split(" ").map((word, index, arr) =>
              index >= arr.length - 3 ? (
                <span key={index} style={{ color: "#0ea5e9" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              ),
            )}
          </h1>
        </div>
        <img
          src={`${API_URL}/${slider?.banner}`}
          alt=""
        />
      </div>
      <div className="service-2 containers">
        <div className="service-2-left">
          <h6 className="upper-p">{whatWeDo?.small_title}</h6>
          <h2>
            {whatWeDo?.main_title?.split(" ").map((word, index, arr) => {
              const targetIndexes = [arr.length - 5, arr.length - 4]; // 3rd & 2nd to last
              return targetIndexes.includes(index) ? (
                <span key={index} style={{ color: "#0ea5e9" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              );
            })}
          </h2>
        </div>
        <div dangerouslySetInnerHTML={{ __html: whatWeDo?.content }} />
      </div>
      <div className="service-3 containers">
        <div className="service-3-upper">
          <h6 className="upper-p">{whyChoseUs?.heading?.small_title}</h6>
          <h2>{whyChoseUs?.heading?.main_title}</h2>
        </div>
        <div className="service-3-down">
          {whyChoseUs?.lists?.slice(1).map((item, index) => {
            let parsedContent = null;

            if (item.content) {
              try {
                const parsed = JSON.parse(item.content);
                if (Array.isArray(parsed)) {
                  parsedContent = parsed;
                }
              } catch (e) {
                parsedContent = null; // not JSON, fallback to string
              }
            }

            return (
              <div className="service-3-card" key={index}>
                {/* Title */}
                <h4>{item.title}</h4>

                <div className="card-3-all-sub">
                  {parsedContent ? (
                    // ✅ If content is JSON array
                    parsedContent?.map((c, idx) => (
                      <div className="card-3-sub" key={idx}>
                        <div className="card-3-circle">
                          <Icon
                            width="12px"
                            height="12px"
                            icon="fluent-mdl2:check-mark"
                            style={{ color: " #ffffff" }}
                          />
                        </div>
                        <p>{c.sub_title}</p>
                      </div>
                    ))
                  ) : item.content ? (
                    // ✅ If content is just a string
                    <div className="card-3-sub">
                      <div className="card-3-circle">
                        <Icon
                          width="12px"
                          height="12px"
                          icon="fluent-mdl2:check-mark"
                          style={{ color: " #ffffff" }}
                        />
                      </div>
                      <p>{item.content}</p>
                    </div>
                  ) : (
                    // ✅ If content is null
                    ""
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="service-4 containers">
        <div className="service-4-upper">
          <h6 className="upper-p">{service?.headings?.small_title}</h6>
          <h2>
            {service?.headings?.main_title
              ?.split(" ")
              .map((word, index, arr) => {
                const targetIndexes = [arr.length - 7, arr.length - 6]; // 3rd & 2nd to last
                return targetIndexes.includes(index) ? (
                  <span key={index} style={{ color: "#0ea5e9" }}>
                    {word}{" "}
                  </span>
                ) : (
                  word + " "
                );
              })}
          </h2>
        </div>
        <div className="service-4-down">
          {service?.services?.map((item) => (
            <div
              onClick={() => handledetails(item?.id)}
              className="service-4-card"
            >
              <img
                src={`${API_URL}/${item?.banner}`}
                alt=""
              />
              <div className="card-4-sub">
                <h4>{item?.main_title}</h4>
                <div className="card-4-circle">
                  <Icon width="14px" height="14px" icon="mdi:arrow-top-right" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <div className="service-5 containers">
        <div className="service-5-left">
            <div className="left-5-upper">
                <h3></h3>
                <img src="" alt="" />
            </div>
            <div className="left-5-circle"></div>
        </div>
        <div className="service-5-right">
            <div className="right-5-upper">
                <div className="right-5-sub">
                    <h6 className="upper-p"></h6>
                    <h4></h4>
                </div>
                <div className="right-5-circle"></div>
            </div>
            <div className="right-5-down">
                <div className="right-5-inner">
                    <h4></h4>
                    <p></p>
                </div>
                 <a
              target="_blank"
              rel="noopener noreferrer"
              href={``}
              className="right-5-btn"
            >
              {}
            </a>
            </div>
        </div>
      </div>
      <div
       
        style={{
          backgroundImage: `url(${API_URL}/)`,
        }}
        className="service-6 containers"
      >
        <div className={`service-6-card`}>
          <div className="service-6-card-upper">
            <h6></h6>
            <div className="small-blue-cirlce"></div>
          </div>
          <div className="service-6-card-middle">
            <h5></h5>
            <h4></h4>
            <div className="service-6-card-down">
              <p></p>
              <a
                href=""
                className="service-6-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                
              </a>
            </div>
          </div>
        </div>
      </div> */}
    </ServiceRap>
  );
};

export default Services;
